const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "110px",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    viewBox: "0 0 110 110",
    width: "110px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Multicolor_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87,87H23v-0.04c0-2.187,1.773-3.96,3.96-3.96h56.08c2.187,0,3.96,1.773,3.96,3.96V87z",
    style: {
      fill: "#E2E4E5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 36,
    style: {
      fill: "#FFFFFF"
    },
    width: 56,
    x: 27,
    y: 47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.143,47c0,2.209-2.047,4-4.571,4S23,49.209,23,47H32.143z",
    style: {
      fill: "#DF2C2C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.286,47c0,2.209-2.047,4-4.571,4s-4.571-1.791-4.571-4H41.286z",
    style: {
      fill: "#CFD3D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.429,47c0,2.209-2.047,4-4.571,4s-4.571-1.791-4.571-4H50.429z",
    style: {
      fill: "#DF2C2C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.571,47c0,2.209-2.047,4-4.571,4s-4.571-1.791-4.571-4H59.571z",
    style: {
      fill: "#CFD3D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.857,47c0,2.209-2.047,4-4.571,4c-2.525,0-4.571-1.791-4.571-4H77.857z",
    style: {
      fill: "#CFD3D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.714,47c0,2.209-2.047,4-4.571,4c-2.525,0-4.571-1.791-4.571-4H68.714z",
    style: {
      fill: "#DF2C2C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,47c0,2.209-2.047,4-4.571,4c-2.525,0-4.571-1.791-4.571-4H87z",
    style: {
      fill: "#DF2C2C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23,47 32.143,47 40.143,27 32.143,27   ",
    style: {
      fill: "#FA5655"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.143,47 41.286,47 47,27 40.143,27   ",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.286,47 50.429,47 53.857,27 47,27   ",
    style: {
      fill: "#FA5655"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.429,47 59.571,47 59.571,27 53.857,27   ",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87,47 77.857,47 72.143,27 79,27   ",
    style: {
      fill: "#FA5655"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.857,47 68.714,47 65.286,27 72.143,27   ",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.714,47 59.571,47 59.571,27 65.286,27   ",
    style: {
      fill: "#FA5655"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 16,
    style: {
      fill: "#6FDAF1"
    },
    width: 28,
    x: 31,
    y: 55
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59,71 31,71 59,55   ",
    style: {
      fill: "#40C9E7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 13,
    style: {
      fill: "#40C9E7"
    },
    width: 14,
    x: 65,
    y: 55
  }), /*#__PURE__*/React.createElement("rect", {
    height: 12,
    style: {
      fill: "#40C9E7"
    },
    width: 14,
    x: 65,
    y: 71
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.978,76c0.26-3.258-3.405-5.625-7.407-5.625c-2.324,0-4.396,0.764-5.759,1.959    c-0.619-1.182-1.646-1.959-2.812-1.959c-1.093,0-2.055,0.692-2.683,1.75c-0.775-1.918-2.607-3.268-4.746-3.268    c-2.5,0-4.58,1.845-5.042,4.288c-0.358-0.31-0.784-0.493-1.243-0.493c-1.355,0-2.406,1.54-2.262,3.348H57.978z",
    style: {
      fill: "#0D9681"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 7,
    style: {
      fill: "#9C6144"
    },
    width: 32,
    x: 26,
    y: 76
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#AF7653"
    },
    width: 32,
    x: 26,
    y: 76
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/shop-icon.048628c95dd89e631ac8c652d04238fb.svg";
export { ForwardRef as ReactComponent };